import { create } from 'zustand';

/**
 * «Пришёл, чтобы войти в голос».
 *
 * Карточка сессии с людьми в голосе (Home, полоса в Discover) ведёт на страницу заявки с
 * `?voice=join`. Сама она в комнату не входит и второй кнопки «Войти» не заводит: пускать или
 * нет, решает единственный блок голоса на странице (`SessionVoice`), у которого пятнадцать
 * состояний входа. Страница кладёт сюда id сессии, блок при первом же состоянии «можно войти»
 * забирает намерение и нажимает свою кнопку сам.
 *
 * Стор, а не переменная модуля: блок монтируется раньше, чем страница узнаёт сессию (эффекты
 * детей бегут первыми), и должен перерисоваться, когда намерение появится.
 */
type VoiceJoinIntentState = {
  sessionId: string | null;
  note: (sessionId: string) => void;
  clear: () => void;
};

export const useVoiceJoinIntent = create<VoiceJoinIntentState>()((set) => ({
  sessionId: null,
  note: (sessionId) => set({ sessionId }),
  clear: () => set({ sessionId: null }),
}));
